import { render, staticRenderFns } from "./BackOrders.vue?vue&type=template&id=73519531&scoped=true"
import script from "./BackOrders.vue?vue&type=script&lang=js"
export * from "./BackOrders.vue?vue&type=script&lang=js"
import style0 from "./BackOrders.vue?vue&type=style&index=0&id=73519531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73519531",
  null
  
)

export default component.exports